import { Helmet } from 'react-helmet-async';
import { useQueryState } from '../../mutations';
import { getQueryParam } from '../../helpers/util';

const HeadComponent = ({title, description, tabTitle, currentEventCode}) => {      
    // Safe JSON parsing with error handling
    const { value: cachedData,clearValue } = useQueryState("eventData");
    const { value: formDetails } = useQueryState("formDetails");
    const { attendee_type } = formDetails || {};
    
    let eventData = {};
    try {
        // const cachedData = localStorage.getItem("eventData");
        if (cachedData) {
            eventData = cachedData;
        }
    } catch (error) {
        console.warn('Failed to parse cached eventData:', error);
        clearValue();
    }
    
    // Clear cache if event code doesn't match
    if (currentEventCode && eventData?.eventCode && eventData.eventCode !== currentEventCode) {
        clearValue();
        eventData = {}; // Reset local state
    }

    // Determine registration type - check formDetails first, fallback to URL r parameter
    const rValue = getQueryParam('r') || localStorage.getItem('r_value');
    const isMedia = attendee_type?.toLowerCase() === "media" || (rValue && rValue.toLowerCase().includes('media'));
    const registrationType = isMedia ? "Media Registration" : "Visitor Registration";

    // Determine if we should use cached title
    const shouldUseCachedTitle = eventData?.title && !title && eventData?.eventCode === currentEventCode;
    
    // Build final title with fallback chain
    const finalTitle = tabTitle || 
                      (title ? `${title} - ${registrationType}` : '') || 
                      (shouldUseCachedTitle ? `${eventData.title} - ${registrationType}` : '') || 
                      `Fairfest Media - ${registrationType}`;

    // Safe description with fallback
    const finalDescription = description || eventData?.description || "DefaultDescription";

    return (
        <Helmet>
            <title>{finalTitle}</title>
            <meta name="description" content={finalDescription} />        
            <meta charset="UTF-8" />
            {/* <meta name="viewport" content="width=device-width, initial-scale=1.0" /> */}
        </Helmet>
    );
};

export default HeadComponent;
